import { getCadastroAdicional } from '@/utils/cadastros-adicionais-utils';
import CadastrosAdicionais from '@/enums/cadastros-adicionais';
import { ErpCamposIntegracao } from 'px-business-components';

const hasCamposErpSankhya = camposIntegracao => camposIntegracao.natureza !== null;

const hasCamposErpTotvs = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpSenior = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpSeniorTeixeira = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpLm = camposIntegracao => camposIntegracao.tipoCobranca !== null;

const hasCamposErpUseall = camposIntegracao => camposIntegracao.condicaoPagamento !== null;

const hasCamposErpUseallSetup = camposIntegracao => camposIntegracao.condicaoPagamento !== null
  && camposIntegracao.observacaoInterna !== null;

const hasCamposErpNeoGabriella = camposIntegracao => camposIntegracao.tipoCompra !== null;

export const hasCadastrosAdicionaisErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return hasCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return hasCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return hasCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return hasCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return hasCamposErpLm(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key) {
    return hasCamposErpUseall(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return hasCamposErpUseallSetup(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return hasCamposErpNeoGabriella(camposIntegracao);
  }
  return false;
};

const validateCamposErpTotvs = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSenior = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSeniorTeixeira = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpLm = (camposIntegracao) => {
  if (!camposIntegracao.tipoCobranca) {
    return [false, 'O tipo de cobrança é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpUseall = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpUseallSetup = (camposIntegracao) => {
  if (!camposIntegracao.condicaoPagamento) {
    return [false, 'Condição de pagamento é obrigatória'];
  }
  if (!camposIntegracao.observacaoInterna) {
    return [false, 'Observação interna é obrigatória'];
  }
  return [true, null];
};

const validateCamposErpSankhya = (camposIntegracao) => {
  if (!camposIntegracao.natureza) {
    return [false, 'Natureza é obrigatório'];
  }
  return [true, null];
};

const validateCamposErpNeoGabriella = (camposIntegracao) => {
  if (!camposIntegracao.tipoCompra) {
    return [false, 'O tipo de compra é obrigatório'];
  }
  return [true, null];
};

export const validateCamposErp = (tipoErp, camposIntegracao) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return validateCamposErpTotvs(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return validateCamposErpSankhya(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return validateCamposErpSenior(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return validateCamposErpSeniorTeixeira(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return validateCamposErpLm(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key) {
    return validateCamposErpUseall(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return validateCamposErpUseallSetup(camposIntegracao);
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return validateCamposErpNeoGabriella(camposIntegracao);
  }
  return [true, null];
};

export const computeFrom = (tipoErp, cadastrosAdicionais) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return {
      natureza: getCadastroAdicional(cadastrosAdicionais, CadastrosAdicionais.keys.NATUREZA.key),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return {
      tipoCobranca: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.TIPO_COBRANCA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key
  ) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return {
      condicaoPagamento: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.CONDICAO_PAGAMENTO.key,
      ),
      observacaoInterna: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.OBSERVACAO_INTERNA.key,
      ),
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      tipoCompra: getCadastroAdicional(
        cadastrosAdicionais,
        CadastrosAdicionais.keys.TIPO_COMPRA.key,
      ),
    };
  }
  return {};
};

export const initialStateCamposErp = (tipoErp) => {
  if (tipoErp === ErpCamposIntegracao.keys.TOTVS.key) {
    return {
      natureza: null,
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SANKHYA.key) {
    return {
      natureza: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.SENIOR_TEIXEIRA.key) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.LM.key) {
    return {
      tipoCobranca: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL.key
    || tipoErp === ErpCamposIntegracao.keys.USEALL_PROCER.key
  ) {
    return {
      condicaoPagamento: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.USEALL_SETUP.key) {
    return {
      condicaoPagamento: null,
      observacaoInterna: null,
    };
  }
  if (tipoErp === ErpCamposIntegracao.keys.NEO_GABRIELLA.key) {
    return {
      tipoCompra: null,
    };
  }
  return {};
};
